export type ShortsWorksWidgetProperties = Record<string, string | string[]>;

export interface ShortsWorksWidgetProps {
  accessKey: string;
  widgetProperties: ShortsWorksWidgetProperties;
  isMobileDevice?: boolean;
}

export const ShortsWorksWidget = ({
    accessKey,
    widgetProperties,
    isMobileDevice
}: ShortsWorksWidgetProps) => {

  return (
    <div className="w-full">
     {/* base64 로 관리하기 */}
      <shorts-works
        access-key={accessKey}
        device={isMobileDevice ? "mobile" : "pc"}
        settings={JSON.stringify(widgetProperties)}
      />
    </div>
  );
};
